import { Module, ActionTree, Store, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { registerSubModule } from '@/utils/vueUtils';

import { InitCountries } from '@/api/CountryStateApi';
import { validate } from '@/forms/FormElements/Rows/AddressRow/AddressRow.api';
import { showToastMessage } from '@/utils/toastUtils';
import ToastType from '@/common/interfaces/enums/ToastType';
import { BrochureRequestFormModel } from './BrochureRequestForm/BrochureRequestForm.types';
import { InterestsFormModel } from './InterestsForm/InterestsForm.types';
import {
  BrochureRequestBlockViewModel,
  InterestsListModel,
  BrochureItem,
  BrochureUpdateCount,
} from './BrochureRequestModule.types';
import {
  submitBrochureRequest,
  submitInterestsRequest,
  getInterests,
} from './BrochureRequestModule.api';
import Address from '@/common/interfaces/dto/Address';
import { MessagesModel } from '@/forms/FormElements/Rows/AddressRow/AddressRow.api';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import BrochureCard from '@/common/interfaces/modules/BrochureCard';

export interface BrochureRequestModuleState {
  IsBrochureFilled: boolean;
  IsBrochureSubmitted: boolean;
  IsInterestsLoaded: boolean;
  IsInterestsSubmitted: boolean;
  BrochureRequestFormModel: BrochureRequestFormModel;
  BrochureRequestId: number;
  InterestsListModel: InterestsListModel;
  IsShowAddresPopup: boolean;
  AddressErrorMessages: MessagesModel;
  AddressValidatorModel: Address;
  IsBtB: boolean;
  IsAddressValidated: boolean;
  ShouldChangeAddress: boolean;
  SelectedBrochures: BrochureItem[];
  IsFilledOnce: boolean;
  IsNewsletterSubscription: boolean;
  FollowUpTransactionID: number;
  BrochureCardData: BrochureCard[]
}

export const SHOW_SUMMARY = 'SHOW_SUMMARY';
export const HIDE_ADDRESS_POPUP = 'HIDE_ADDRESS_POPUP';
export const BACK_TO_FORM = 'BACK_TO_FORM';
export const SUBMIT_BROCHURES = 'SUBMIT_BROCHURES';
export const VALIDATE_ADDRESS = 'VALIDATE_ADDRESS';
export const SUBMIT_INTERESTS = 'SUBMIT_INTERESTS';
export const SET_SUGGESTED_ADDRESS = 'SET_SUGGESTED_ADDRESS';
export const UPDATE_BROCHURE_COUNT = 'UPDATE_BROCHURE_COUNT';

const actions: ActionTree<BrochureRequestModuleState, RootState> = {
  async [SHOW_SUMMARY]({ state, commit }, model: BrochureRequestFormModel) {
    model.SelectedBrochures = state.SelectedBrochures;
    //console.log('show', model);
    commit(SET_FILLED_ONCE);
    commit(SET_BROCHURE_MODEL, model);
    commit(SET_BROCHURE_FILLED, true);

    VueScrollTo.scrollTo(document.querySelector('#Header'), {
      duration: 0,
    });
  },
  async [BACK_TO_FORM]({ commit }) {
    commit(SET_BROCHURE_FILLED, false);
    commit(SET_ADDRESS_VALIDATOR_MODEL, null);
    commit(SET_ADDRESS_VALIDATED, false);
    commit(SET_ADDRESS_ERROR_MESSAGES, {});
    commit(SET_SHOULD_CHANGE_ADDRESS, false);
  },

  async [VALIDATE_ADDRESS]({ state, commit, dispatch }, model: BrochureRequestFormModel) {
    model.SelectedBrochures = state.SelectedBrochures;
    commit(SET_BROCHURE_MODEL, model);

    if (model.IsSubscribe) {
      commit(SET_NEWSLETTER_SUBSCRIPTION);
    }

    if (!state.IsShowAddresPopup) {
      //TODO: use AddressRow.helper when fixed
      const usId = 385;
      if (model.Address.CountryId != usId) {
        commit(SET_ADDRESS_VALIDATED, true);
        dispatch(SHOW_SUMMARY, model);
        return;
      }

      const result = await validate(model.Address, { showLoading: false, cacheResults: true });
      //console.log('Validation: ', result);
      if ((result.Item as MessagesModel).Messages) {
        commit(SET_ADDRESS_ERROR_MESSAGES, result.Item);
        commit(SET_ADDRESS_VALIDATOR_MODEL, null);
        commit(SET_SHOW_POPUP, true);
      } else if ((result.Item as Address).CountryId) {
        commit(SET_ADDRESS_VALIDATOR_MODEL, result.Item);
        commit(SET_ADDRESS_ERROR_MESSAGES, []);
        commit(SET_SHOW_POPUP, true);
      } else {
        commit(SET_ADDRESS_VALIDATED, true);
        dispatch(SHOW_SUMMARY, model);
      }
      return;
    }
    commit(SET_SHOW_POPUP, false);
  },
  async [SET_SUGGESTED_ADDRESS]({ state, commit, dispatch }, shouldSetSuggested: boolean) {
    if (shouldSetSuggested) {
      commit(SET_ADDRESS_MODEL, state.AddressValidatorModel);
    }
    commit(SET_SHOULD_CHANGE_ADDRESS, shouldSetSuggested);
    commit(SET_ADDRESS_VALIDATED, true);
    dispatch(HIDE_ADDRESS_POPUP);
    dispatch(SHOW_SUMMARY, state.BrochureRequestFormModel);
  },

  async [SUBMIT_BROCHURES]({ state, commit }, payload: any) {
    

    const result = await submitBrochureRequest(
      payload,
      this.state.Meta.Country,
      state.IsBtB,
    );

    //console.log('from server', result);

    if (result.IsOk) {
      if (state.IsBtB) {
        commit(SET_INTERESTS_SUBMITTED);
        commit(SET_BROCHURE_SUBMITTED);
        return;
      }
      commit(SET_BROCHURE_ID, result.Item.Id);

      const interestsResult = await getInterests(this.state.Meta.Country);
      if (interestsResult.IsOk) {
        //console.log('Interests from server', interestsResult);
        commit(SET_INTERESTS_LIST, interestsResult.Item);
        commit(SET_INTERESTS_LOADED);
      } else {
        //console.log('error', interestsResult);
        // TODO show tout or catch in form and show on fields
      }
      commit(SET_BROCHURE_SUBMITTED);
    } else {
      //console.log('error', result);
      // TODO show tout or catch in form and show on fields
      showToastMessage([
        {
          Text: result.Error,
          Type: ToastType.Danger,
        },
      ]);
    }
  },

  async [SUBMIT_INTERESTS]({ state, commit }, model: InterestsFormModel) {
    const result = await submitInterestsRequest(state.BrochureRequestId, model);
    if (result.IsOk) {
      //console.log('from server', result);
      commit(SET_FOLLOW_UP_TRANSACTION_ID, result.Item.transaction_id)
      commit(SET_INTERESTS_SUBMITTED);
    } else {
      //console.log('error', result);
      // TODO show tout or catch in form and show on fields
    }
  },
  async [HIDE_ADDRESS_POPUP]({ commit }) {
    commit(SET_SHOW_POPUP, false);
  },
};

const SET_BROCHURE_FILLED = 'SET_BROCHURE_FILLED';
const SET_BROCHURE_MODEL = 'SET_BROCHURE_MODEL';
const SET_ADDRESS_MODEL = 'SET_ADDRESS_MODEL';
const SET_SHOULD_CHANGE_ADDRESS = 'SET_SHOULD_CHANGE_ADDRESS';
const SET_BROCHURE_SUBMITTED = 'SET_BROCHURE_SUBMITTED';
const SET_INTERESTS_SUBMITTED = 'SET_INTERESTS_SUBMITTED';
const SET_BROCHURE_ID = 'SET_BROCHURE_ID';
const SET_INTERESTS_LIST = 'SET_INTERESTS_LIST';
const SET_INTERESTS_LOADED = 'SET_INTERESTS_LOADED';
const SET_SHOW_POPUP = 'SET_SHOW_POPUP';
const SET_ADDRESS_ERROR_MESSAGES = 'SET_ADDRESS_ERROR_MESSAGES';
const SET_ADDRESS_VALIDATOR_MODEL = 'SET_ADDRESS_VALIDATOR_MODEL';
const SET_ADDRESS_VALIDATED = 'SET_ADDRESS_VALIDATED';
const SET_FILLED_ONCE = 'SET_FILLED_ONCE';
const SET_NEWSLETTER_SUBSCRIPTION = 'SET_NEWSLETTER_SUBSCRIPTION';
const SET_FOLLOW_UP_TRANSACTION_ID = 'SET_FOLLOW_UP_TRANSACTION_ID';

const mutations: MutationTree<BrochureRequestModuleState> = {
  [SET_BROCHURE_FILLED](state, value: boolean) {
    state.IsBrochureFilled = value;
  },
  [SET_BROCHURE_MODEL](state, model: BrochureRequestFormModel) {
    Vue.set(state, 'BrochureRequestFormModel', model);
  },
  [SET_ADDRESS_MODEL](state, model: Address) {
    Vue.set(state.BrochureRequestFormModel, 'Address', model);
  },
  [SET_BROCHURE_SUBMITTED](state) {
    state.IsBrochureSubmitted = true;
  },
  [SET_INTERESTS_LOADED](state) {
    state.IsInterestsLoaded = true;
  },
  [SET_INTERESTS_SUBMITTED](state) {
    state.IsInterestsSubmitted = true;
    Vue.nextTick(() => {
      VueScrollTo.scrollTo('#app');
    });
  },
  [SET_BROCHURE_ID](state, id: number) {
    state.BrochureRequestId = id;
  },
  [SET_FOLLOW_UP_TRANSACTION_ID](state, id: number) {
    state.FollowUpTransactionID = id;
  },
  [SET_INTERESTS_LIST](state, interests: InterestsListModel) {
    state.InterestsListModel = interests;
  },
  [SET_SHOW_POPUP](state, shouldShow: boolean) {
    state.IsShowAddresPopup = shouldShow;
  },
  [SET_ADDRESS_ERROR_MESSAGES](state, addressErrorMessages: MessagesModel) {
    state.AddressErrorMessages = addressErrorMessages;
  },
  [SET_ADDRESS_VALIDATOR_MODEL](state, model: Address) {
    state.AddressValidatorModel = model;
  },
  [SET_ADDRESS_VALIDATED](state, isValidated: boolean) {
    state.IsAddressValidated = isValidated;
  },
  [SET_SHOULD_CHANGE_ADDRESS](state, shouldChange: boolean) {
    state.ShouldChangeAddress = shouldChange;
  },
  [UPDATE_BROCHURE_COUNT](state, payload: BrochureUpdateCount) {
    //console.log(state.SelectedBrochures);
    const brochure = state.SelectedBrochures.find((b) => b.Id === payload.Id);
    if (brochure) {
      brochure.Count = payload.Count;
    }
  },
  [SET_FILLED_ONCE](state) {
    state.IsFilledOnce = true;
  },
  [SET_NEWSLETTER_SUBSCRIPTION](state) {
    state.IsNewsletterSubscription = true;
  },
};

const registerModule = registerSubModule<BrochureRequestModuleState, BrochureRequestBlockViewModel>(
  (data: BrochureRequestBlockViewModel) => {
    return {
      namespaced: true,
      state: {
        IsBrochureFilled: false,
        IsBrochureSubmitted: false,
        IsInterestsLoaded: false,
        IsInterestsSubmitted: false,
        BrochureRequestId: 0,
        IsShowAddresPopup: false,
        AddressErrorMessages: {},
        AddressValidatorModel: null,
        IsBtB: data.IsBtB,
        IsAddressValidated: false,
        ShouldChangeAddress: false,
        SelectedBrochures: data.SelectedBrochures,
        IsFilledOnce: false,
        FollowUpTransactionID: 0,
        BrochureCardData: data.BrochureCardData,
      },
      actions,
      mutations,
    } as Module<BrochureRequestModuleState, RootState>;
  },
  'BrochureRequestModule',
);

export default async (store: Store<RootState>, data: BrochureRequestBlockViewModel) => {
  await InitCountries();

  return registerModule(store, data);
};
